import React from 'react';
import styled from 'styled-components';
import { MobileWidth } from '../sharedData/Constants';

const MobileBreakLine = () => {
    return(
        <StyledMobileBreakLine>
        </StyledMobileBreakLine>
    );
}

const StyledMobileBreakLine = styled.br`
    display: none;
    @media screen and (max-width: ${MobileWidth}) {
        display: block;
    }
`;

export default MobileBreakLine;